import { Component } from "react";
import { SupportApiManager } from "../supportApiManager";
import keycloak from "../../util/keycloak";
import { Button, Col, Container, FormControl, FormLabel, InputGroup, ListGroup, ListGroupItem, Row, Stack } from "react-bootstrap";

export class SupportDashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            districts: [],
            createDistrictMode: false,
            newSchool: '',
        }
        this.apiManager = new SupportApiManager()
    }

    async refreshDistrictList() {
        const districts = await this.apiManager.getDistricts()
        this.setState({districts})
    }

    async refreshPublicKeys() {
        const publicKeys = await this.apiManager.getPublicKeys()
        this.setState({publicKeys})
    }

    async componentDidMount() {
        if (!this.apiManager.hasValidAuthToken()) {
            keycloak.login()
            return
        }
        await this.refreshDistrictList()
        await this.refreshPublicKeys()
    }

    async getSchoolsForDistrict(districtCode) {
        const schools = await this.apiManager.getSchoolsForDistrict(districtCode)
        this.setState({focusedDistrictSchools: schools})
    }

    setFocusedDistrict = async (district) => {
        this.setState({
            focusedDistrict: district,
            focusedDistrictKey: this.state.publicKeys.find(key => key.realm === district.districtCode)?.authKey,
            createDistrictMode: false,
            newSchool: '',
        })
        this.getSchoolsForDistrict(district.districtCode)
    }


    createDistrictMode = () => {
        this.setState({
            createDistrictMode: true,
            focusedDistrict: {
                districtCode: '',
                districtName: '',
            },
            focusedDistrictKey: '',
            newSchool: '',
        })
    }

    updateDistrictValue = field => (e) => {
        if (field !== 'focusedDistrictKey' && field !== 'newSchool') {
            this.setState({
                focusedDistrict: {
                    ...this.state.focusedDistrict,
                    [field]: e.target.value,
                }
            })
            return
        }
        this.setState({
            [field]: e.target.value,
        })
    }

    cancelCreate = () => {
        this.setState({
            focusedDistrict: undefined,
            focusedDistrictKey: undefined,
            createDistrictMode: false,
        })
    }

    createNewDistrict = async () => {
        if (!this.validateDistrictInfo()) {
            return
        }
        const districtInfo = {
            districtName: this.state.focusedDistrict.districtName,
            districtCode: this.state.focusedDistrict.districtCode,
            authKey: this.state.focusedDistrictKey,
        }
        const result = await this.apiManager.createDistrict(districtInfo)
        if (!result) {
            return
        }
        alert(`New district, ${this.state.focusedDistrict.districtName}, created`)
        this.cancelCreate()
        this.refreshDistrictList()
        this.refreshPublicKeys()
    }

    validateDistrictInfo() {
        const districtCodeRegex = /^[a-zA-Z0-9-]{3,25}$/
        if (!this.state.focusedDistrict.districtName) {
            alert('District info cannot be empty')
            return false
        }
        if (this.state.districts.some(district =>
            district.districtCode === this.state.focusedDistrict.districtCode
            || district.districtName === this.state.focusedDistrict.districtName)
        ) {
            alert('District info cannot be the same as an existing district')
            return false
        }
        if (!this.state.focusedDistrict.districtCode || !districtCodeRegex.test(this.state.focusedDistrict.districtCode)) {
            alert('District code must be alphanumeric between 3 and 25 character.')
            return false
        }
        if ((!this.state.focusedDistrictKey || !this.state.focusedDistrictKey?.trim())
            && !this.state.publicKeys.some(keyItem => keyItem.realm === this.state.focusedDistrict.districtCode)
        ) {
            alert('Existing key does not exist with district code entered')
            return false
        }
        return true
    }

    createNewSchoolForDistrict = async () => {
        if (!this.state.focusedDistrict) {
            alert('No district selected')
            return
        }
        if (!this.state.newSchool) {
            alert('New school must not be empty')
            return
        }
        if (this.state.focusedDistrictSchools && this.state.focusedDistrictSchools.some(school => school === this.state.newSchool)) {
            alert('New school cannot be the same as an existing school in the district')
            return
        }
        const result = this.apiManager.addSchool(this.state.focusedDistrict.districtCode, this.state.newSchool)
        if (result) {
            this.setState({newSchool: ''})
            alert(`Added new school, ${this.state.newSchool}, for district ${this.state.focusedDistrict.districtName}`)
            this.getSchoolsForDistrict(this.state.focusedDistrict.districtCode)
        }
    }

    render() {
        return (
            <Container fluid className="p-4">
                <Row>
                    <Col className="px-4" xs={12} lg={6}>
                        <Stack className="justify-content-between" direction="horizontal">
                            <h3 className="mt-3">Districts</h3>
                            {!this.state.createDistrictMode && <Button onClick={() => this.createDistrictMode()}>Create District</Button>}
                        </Stack>
                        <ListGroup className="my-3">
                            {this.state.districts.map(((item, idx) => 
                                <ListGroupItem action key={idx} onClick={() => this.setFocusedDistrict(item)} active={!this.state.createDistrictMode && this.state.focusedDistrict?.districtCode === item.districtCode}>
                                    <Stack className="justify-content-between" direction="horizontal">
                                        <span>{item.districtName} <span>{`(${item.districtCode})`}</span></span>
                                        {this.state.focusedDistrict?.districtCode === item.districtCode && !this.state.createDistrictMode
                                            ? <i class="bi bi-caret-right-fill"></i>
                                            : <i class="bi bi-caret-right"></i>
                                        }
                                    </Stack>
                                    
                                </ListGroupItem>
                            ))}
                            {(this.state.districts.length < 1) &&
                                <ListGroupItem>No districts associated with Teach Insights</ListGroupItem>
                            }
                        </ListGroup>
                    </Col>
                    {this.state.focusedDistrict &&
                        <Col className="px-4" xs={12} lg={6}>
                            <h3>District Info</h3>
                            <Container>
                                <FormLabel htmlFor="district-name">District name</FormLabel>
                                <InputGroup>
                                    <FormControl
                                        id="district-name"
                                        readOnly={!this.state.createDistrictMode}
                                        disabled={!this.state.createDistrictMode}
                                        value={this.state.focusedDistrict.districtName}
                                        onChange={this.updateDistrictValue('districtName')}
                                    />
                                </InputGroup>
                                <FormLabel className="mt-2" htmlFor="district-code">District code</FormLabel>
                                <InputGroup>
                                    <FormControl
                                        id="district-code"
                                        readOnly={!this.state.createDistrictMode}
                                        disabled={!this.state.createDistrictMode}
                                        value={this.state.focusedDistrict.districtCode}
                                        onChange={this.updateDistrictValue('districtCode')}
                                    />
                                </InputGroup>
                                <FormLabel className="mt-2" htmlFor="district-key">
                                    District key {this.state.createDistrictMode && <small>(Leave blank if already exists)</small>}
                                </FormLabel>
                                <InputGroup>
                                    <FormControl
                                        id="district-key"
                                        as="textarea"
                                        readOnly={!this.state.createDistrictMode}
                                        disabled={!this.state.createDistrictMode}
                                        value={this.state.focusedDistrictKey}
                                        onChange={this.updateDistrictValue('focusedDistrictKey')}
                                    />
                                </InputGroup>
                            </Container>
                            {!this.state.createDistrictMode && <Container className="mt-3">
                                <h5>District Schools</h5>
                                <ListGroup>
                                    {this.state.focusedDistrictSchools && this.state.focusedDistrictSchools.map((item, idx) =>
                                      <ListGroupItem key={idx}>{item}</ListGroupItem>  
                                    )}
                                    {!this.state.focusedDistrictSchools &&
                                        <ListGroupItem>No schools in district</ListGroupItem>
                                    }
                                </ListGroup>
                                <InputGroup className="mt-2">
                                    <FormControl value={this.state.newSchool} onChange={this.updateDistrictValue('newSchool')} placeholder="School name" />
                                    <Button onClick={() => this.createNewSchoolForDistrict()}>Add school</Button>
                                </InputGroup>
                            </Container>}
                            {this.state.createDistrictMode && <Stack className="m-2" direction="horizontal">
                                <Button className="me-3" onClick={() => this.createNewDistrict()}>Create</Button>
                                <Button variant="danger" onClick={() => this.cancelCreate()}>Cancel</Button>
                            </Stack>}
                        </Col>
                    }
                </Row>
            </Container>
        )
    }
}